import { E } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/api/auth/auth.service';
import { CarService } from 'src/app/services/api/cars/car.service';
import { LocationService } from 'src/app/services/api/locations/location.service';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  carBrands: any;
  carModels: any;
  isInitialLoad:boolean = true;
  selectedBrand: any;
  disableCarBrand: boolean = true;
  disableCarModel: boolean = true;
  states: any;
  cities: any = [];
  selectedState: any;
  disableCity: boolean = true;
  newData: any;
  isEditing: boolean = false;
  isType: boolean = false;
  isModel: boolean = false;
  editCar: boolean = false;
  thalamusState: any = '';
  newUser: any;
  avatarUrl : any = false;
  errors: any = {};

  transferSuccess: boolean = false;
  transferError: boolean = false;
  showTransferModal: boolean = false;    
  currentUser: any;
  guestUser: boolean = true;
  userToken?: string | null;
  userBalance: number = 0;
  isResetPassword: boolean = false;

  savingChanges: boolean = false;

  showpass : boolean = false;
  showpass1 : boolean = false;
  showpass2 : boolean = false;
  changePasswordForm: any;
  errorChange: string = '';
  updatePass : boolean = false;
  isShowPassword: boolean = false;
  showPassword1 : boolean = false;
  showPassword2 : boolean = false;
  showPassword3 : boolean = false;
  passwordForm: FormGroup;
  isCurrentPasswordValid: boolean = false;
  userForm: FormGroup;
  ChangePasswordSuccess: boolean = false;
  isVisibleModalRecupero: boolean = false;
  isSendRecuperation: boolean = false;


  constructor(
    private formBuilder: FormBuilder,
    public authService: AuthService,

  ) {
   }

  async ngOnInit() {
    await this.handleUser();
    await this.initPasswordForm();
    await this.initUserForm()

    this.userForm.valueChanges.subscribe(() => {
      this.isInitialLoad = false;
    });
  }

  

  private formatBirthday(timestamp: string): string {
    if (!timestamp) return '';
    const date = new Date(parseInt(timestamp));
    return date.toISOString().split('T')[0];
  }

  private hideSuccessMessage() {
    if (this.ChangePasswordSuccess) {
      setTimeout(() => {
        this.ChangePasswordSuccess = false;
      }, 3000);
    }
  }
  
  private async initUserForm() {
    const profile = this.currentUser?.person?.profile;
    const birthday = this.formatBirthday(profile?.birthday);
    
    this.userForm = this.formBuilder.group({
      email: [{ 
        value: profile?.email || '', 
        disabled: true 
      }],
      document: [{ 
        value: profile?.document?.number || '', 
        disabled: true 
      }],
      
      fullName: [
        `${profile?.firstname || ''} ${profile?.lastname || ''}`.trim(), 
        [Validators.required]
      ],
      birthDate: [
        birthday,
        [Validators.required]
      ],
      phoneCode: [
        profile?.cellphone?.areaCode || '11', 
        [
          Validators.required, 
          Validators.pattern('^[0-9]{2}$')
        ]
      ],
      phoneNumber: [
        profile?.cellphone?.number || '', 
        [
          Validators.required, 
          Validators.pattern('^[0-9]{8}$')
        ]
      ]
    });
  }

  private initPasswordForm() {
    this.passwordForm = this.formBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(new RegExp('^(?=.*\\p{Ll})(?=.*\\p{Lu})(?=.*\\d)(?=.*[!@#$%^&*\.])[\\p{L}\\p{N}!@#$%^&*\.]{8,}$', 'u'))
      ]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });
  }


  get f() { 
    return this.passwordForm.controls; 
  }

  private passwordMatchValidator(fg: FormGroup) {
    const newPassword = fg.get('newPassword');
    const confirmPassword = fg.get('confirmPassword');
    
    if (!newPassword || !confirmPassword) {
      return null;
    }
    
    return newPassword.value === confirmPassword.value 
      ? null 
      : { mismatch: true };
  }


  async onSubmitUser() {
    if (this.userForm.invalid) return;
    this.isEditing = true;

    const userData = {
        firstname: this.userForm.value.fullName.split(' ')[0],
        lastname: this.userForm.value.fullName.split(' ').slice(1).join(' '),
        address: {
            city: this.currentUser?.person?.profile?.address?.city,
            streetName: this.currentUser?.person?.profile?.address?.name,
            streetNumber: this.currentUser?.person?.profile?.address?.street1,
            floorApartament: this.currentUser?.person?.profile?.address?.street2,
            postalCode: this.currentUser?.person?.profile?.address?.postalCode,
            stateId: this.currentUser?.person?.profile?.address?.stateId 
        },
        birthday: this.userForm.value.birthDate,
        car: {
            ano_vehiculo: this.currentUser?.person?.profile?.ano_vehiculo,
            marca_auto: this.currentUser?.person?.profile?.marca_auto,
            modelo_auto: this.currentUser?.person?.profile?.modelo_auto,
            patente_auto: this.currentUser?.person?.profile?.patente_auto,
            tipo_vehiculo: this.currentUser?.person?.profile?.tipo_vehiculo,
        },
        cellphone: {
            number: this.userForm.value.phoneNumber,
            areaCode: this.userForm.value.phoneCode
        }
    };

    try {
        await this.authService.update(userData).toPromise();
        
        this.authService.getPerson().subscribe(
            (data) => {
                this.authService.refreshUser(data);
                sessionStorage.setItem('updateProfile', 'true');
                window.location.reload();
            },
            (err) => {
                console.error('Error refreshing user data:', err);
            }
        );
    } catch (err) {
        console.error('Error updating user:', err);
    } finally {
        this.isEditing = false;
    }
}

  onSubmitPassword() {
  
    if (this.passwordForm.invalid) return;
    this.isEditing = true;
      const oldPassword = this.passwordForm.get('currentPassword')?.value;
      const newPassword = this.passwordForm.get('newPassword')?.value;
      const confirmNewPassword = this.passwordForm.get('confirmPassword')?.value;
  
      this.authService.changePassword(oldPassword, newPassword, confirmNewPassword)
      .subscribe({
        next: () => {
          this.isShowPassword = false;
          this.ChangePasswordSuccess = true;
          this.isEditing = false;
          this.passwordForm.reset();
          this.hideSuccessMessage();
          this.isCurrentPasswordValid = false;
          this.errorChange = '';
        },
        error: (err:any) => {
          this.isEditing = false;
          this.isCurrentPasswordValid = true
          this.errorChange = 'La contraseña actual no es la correcta';
        }
      });
    }

    showPassword() {
      this.isShowPassword = !this.isShowPassword;
      this.ChangePasswordSuccess = false;
    }



  get passwordValidations() {
    const password = this.passwordForm?.get('newPassword')?.value || '';
    return {
      hasUpperCase: /[A-Z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasMinLength: password.length >= 8,
      hasLowerCase: /[a-z]/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };
  }
  
  get isPasswordValid(): boolean {
    const validations = this.passwordValidations;
    return validations.hasUpperCase && 
           validations.hasNumber && 
           validations.hasMinLength && 
           validations.hasLowerCase && 
           validations.hasSpecialChar;
  }

  get passwordsMatch(): boolean {
    const newPassword = this.passwordForm?.get('newPassword')?.value;
    const confirmPassword = this.passwordForm?.get('confirmPassword')?.value;
    return newPassword && confirmPassword && newPassword === confirmPassword;
  }
  


  deleteErrors() {
    this.errorChange = '';
  }


  validatePassword(): void{

    if (this.changePasswordForm.get('newPassword')?.value !== this.changePasswordForm.get('confirmNewPassword')?.value ){
      this.errorChange = 'Las contraseñas no coinciden';
    }

    else if ( !this.validatePasswordRequirements(this.changePasswordForm.get('newPassword').value)){
      this.errorChange = 'La contraseña debe contener: 1 mayúscula, 1 número, 1 signo y debe ser mínimo de 8 dígitos';
    }

    else{
      this.errorChange = '';
      this.changePasswordForm.get('password').setValue('confirmNewPassword');

    }

  }

  validatePasswordRequirements( password: string )
  {
    const regExp = new RegExp(/(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,}/);
    const valid  = regExp.test( password );

    return valid;
  }


  updateInfo(event: any) {
    this.savingChanges = true;
    event.preventDefault();
    const fullData = {
      ...this.newData,
    };
    let tthis = this;
    this.authService
      .update(fullData)
      .toPromise()
      .then((res) => {
        tthis.authService.getPerson().subscribe((data) => {
          tthis.authService.refreshUser(data);
          this.savingChanges = false;
          sessionStorage.setItem('updateProfile', 'true');
          location.reload();
        });
      })
      .catch((err) => {
        this.savingChanges = false;
        
        if (err && err.error && err.error.errors) {
          this.errors = err.error.errors;
          if (this.errors['car.patente_auto']) {
            const patenteError = this.errors['car.patente_auto'][0];
            if (patenteError.includes("Formato de patente inválido")) {
              this.errors['car.invalidFormat'] = "Formato de patente inválido.";
            }
          }
        }
        if (err.status !== 400) {
          sessionStorage.setItem('transferError', 'true');
          location.reload();
        } else {
          console.error('Error 400: No se mostrará el modal de error.', err);
        }
      });
  }

  async handleUser(){
    this.currentUser = await this.authService.getCurrentUser();
    this.userToken = await this.authService.getAccessToken();
    this.avatarUrl = await this.authService.getCurrentAvatar();

    this.guestUser = !(this.userToken != null && this.userToken.length > 0);

    if(!this.guestUser && this.currentUser.context.activities.length){
      this.userBalance = this.currentUser.context.activities[0].personStatus.accountBalance;
    }
  }

  onLoginModalClosed() {
    this.isResetPassword = !this.isResetPassword;
  }

  async showModalRecupero() {
    this.isSendRecuperation = true;
    document.getElementsByTagName('body')[0].classList.add('noScroll');

    await this.authService.passwordRecover(this.currentUser?.person?.profile?.email).subscribe({
      next: () => {
        this.isSendRecuperation = false;
        this.isVisibleModalRecupero = true;
      },
      error: (err) => {
        this.isSendRecuperation = false;
        console.error('Error al recuperar contraseña:', err);
      }
    });

  }

  closeLogin() {
    this.isVisibleModalRecupero = false;
    document.body.classList.remove('noScroll');
  }
}
